/**
 * Web counterpart of the permissions step's notifications section. The web
 * build has no push notification permission to explain, so the section is
 * absent rather than conditionally rendered.
 */
export function PermissionsNotificationsSection() {
  return null;
}
